/* KOJO custom layer — cart extras (module M3). Requires window.KJ from kojo-core.js.
   - Packaging upgrade (Estándar → Premium) in drawer and cart page
   - Cart page: qty / remove / upsell add (drawer ones are handled by <kj-cart-drawer> in core)
   - Quick add of empty-state cards inside the drawer
   - Upsell size select: visible label, "pick a size first" hint, auto-add after picking
   - Meter fill animation between re-renders, focus restore, live region, checkout loading, mobile sticky bar */
(function () {
  'use strict';
  if (window.__kjCartExtras) return;
  window.__kjCartExtras = true;

  var doc = document;
  function K() { return window.KJ; }
  function closest(el, sel) { return el && el.closest ? el.closest(sel) : null; }
  function cssEsc(v) { return window.CSS && CSS.escape ? CSS.escape(v) : String(v).replace(/"/g, '\\"'); }
  function pageRoot() { return doc.querySelector('[data-kj-cart-section]'); }
  function drawerEl() { return doc.querySelector('kj-cart-drawer'); }
  function setLoading(btn, on) { var k = K(); if (k && k.setLoading) k.setLoading(btn, on); }
  function toastError(msg) { var k = K(); if (k && k.toast) k.toast(msg || (k.t ? k.t('cart_error') : 'Error'), 'error'); }

  /* ---------- meter animation: remember last width per meter, animate from it after re-render ---------- */
  var lastPct = {};
  function meterKey(m) { return closest(m, 'kj-cart-drawer') ? 'drawer' : 'page'; }
  function readPct(fill) { return (fill.style.getPropertyValue('--kj-pct') || '0%').trim(); }
  function snapshotMeters() {
    doc.querySelectorAll('[data-kj-meter-fill]').forEach(function (f) { lastPct[meterKey(f)] = readPct(f); });
  }
  function animateMeters(scope) {
    (scope || doc).querySelectorAll('[data-kj-meter-fill]').forEach(function (f) {
      var key = meterKey(f), from = lastPct[key], to = readPct(f);
      lastPct[key] = to;
      if (!from || from === to || (K() && K().reducedMotion && K().reducedMotion())) return;
      f.style.transition = 'none';
      f.style.width = from;
      void f.offsetWidth;
      f.style.transition = '';
      f.style.width = '';
    });
  }

  /* ---------- focus restore after a re-render ---------- */
  var lastFocusSel = null;
  function describe(el) {
    if (!el || !el.matches) return null;
    var line = closest(el, '[data-key]');
    var lineSel = line ? '[data-key="' + cssEsc(line.getAttribute('data-key')) + '"] ' : '';
    if (el.matches('[data-kj-qty]')) return lineSel + '[data-kj-qty="' + el.getAttribute('data-kj-qty') + '"]';
    if (el.matches('input[data-kj-qty-input]')) return lineSel + 'input[data-kj-qty-input]';
    if (el.matches('.kj-cart__close')) return '.kj-cart__close';
    return null;
  }
  doc.addEventListener('focusin', function (e) {
    if (closest(e.target, 'kj-cart-drawer') || closest(e.target, '[data-kj-cart-section]')) lastFocusSel = describe(e.target);
  });
  function restoreFocus(root) {
    if (!root) return;
    var active = doc.activeElement;
    if (active && active !== doc.body && active !== doc.documentElement) return;
    var target = null;
    if (lastFocusSel) { try { target = root.querySelector(lastFocusSel); } catch (e) { target = null; } }
    if (target && target.disabled) target = null;
    if (!target) {
      if (root.tagName === 'KJ-CART-DRAWER') target = root.querySelector('[role="dialog"]');
      else return;
    }
    try { target.focus({ preventScroll: true }); } catch (e) {}
  }

  /* ---------- live region ---------- */
  function announce(cart) {
    var live = doc.querySelector('[data-kj-cart-live]');
    if (!live || !cart) return;
    var n = cart.item_count || 0;
    live.textContent = 'Carrito actualizado: ' + n + (n === 1 ? ' artículo' : ' artículos') + (K() && K().formatMoney ? ', total ' + K().formatMoney(cart.total_price) : '') + '.';
  }

  /* ---------- upsell select UI ---------- */
  function syncSelects(scope) {
    (scope || doc).querySelectorAll('select[data-kj-variant-select]').forEach(function (sel) {
      var holder = closest(sel, '[data-kj-upsell]');
      var ui = holder && holder.querySelector('[data-kj-select-ui]');
      if (ui && sel.value) ui.textContent = sel.options[sel.selectedIndex].text;
      if (holder) holder.classList.toggle('has-value', !!sel.value);
    });
  }
  function askForSize(holder, sel) {
    holder.classList.remove('is-invalid');
    void holder.offsetWidth;
    holder.classList.add('is-invalid');
    holder.setAttribute('data-kj-pending', '1');
    try { if (sel.showPicker) { sel.showPicker(); return; } } catch (e) {}
    try { sel.focus(); } catch (e) {}
  }
  doc.addEventListener('change', function (e) {
    var sel = closest(e.target, 'select[data-kj-variant-select]');
    if (!sel) return;
    var holder = closest(sel, '[data-kj-upsell]');
    if (!holder) return;
    syncSelects(holder);
    holder.classList.remove('is-invalid');
    if (holder.getAttribute('data-kj-pending') && sel.value) {
      holder.removeAttribute('data-kj-pending');
      var btn = holder.querySelector('[data-kj-add]');
      if (btn) btn.click();
    }
  });

  /* ---------- click delegation ---------- */
  doc.addEventListener('click', function (e) {
    var k = K();
    if (!k || !k.cart) return;

    // 1) Packaging upgrade (drawer + page)
    var up = closest(e.target, '[data-kj-pack-upgrade]');
    if (up) {
      e.preventDefault();
      if (up.getAttribute('aria-busy') === 'true') return;
      var updates = {};
      updates[up.getAttribute('data-from-key')] = 0;
      updates[up.getAttribute('data-to')] = (parseInt(up.getAttribute('data-to-qty'), 10) || 0) + (parseInt(up.getAttribute('data-qty'), 10) || 1);
      setLoading(up, true);
      var updUrl = ((k.routes && k.routes.cartUpdate) || '/cart/update') + '.js';
      fetch(updUrl, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest', 'X-Kojo': '1' },
        body: JSON.stringify({ updates: updates })
      })
        .then(function (r) {
          return r.json().catch(function () { return {}; }).then(function (j) {
            if (!r.ok || j.status) throw new Error(j.description || j.message || '');
            return j;
          });
        })
        .then(function () { snapshotMeters(); return k.cart.refresh(); })
        .then(function () { var live = doc.querySelector('[data-kj-cart-live]'); if (live) live.textContent = 'Packaging Premium añadido.'; })
        .catch(function (err) { toastError(err && err.message); })
        .finally(function () { if (doc.contains(up)) setLoading(up, false); });
      return;
    }

    // 2) Upsell add without a size chosen (drawer: core ignores it silently; page: we handle everything)
    var add = closest(e.target, '[data-kj-add]');
    if (add) {
      var holder = closest(add, '[data-kj-upsell]');
      var sel = holder && holder.querySelector('select[data-kj-variant-select]');
      var inDrawer = !!closest(add, 'kj-cart-drawer');
      if (sel && !sel.value) { e.preventDefault(); askForSize(holder, sel); return; }
      if (inDrawer) { snapshotMeters(); return; } // core adds it
      if (!closest(add, '[data-kj-cart-section]')) return;
      e.preventDefault();
      var vid = sel ? sel.value : add.getAttribute('data-kj-add');
      if (!vid) return;
      snapshotMeters();
      setLoading(add, true);
      k.cart.add([{ id: vid, quantity: 1 }], { source: 'cart-page-upsell', open: false })
        .catch(function () {})
        .finally(function () { if (doc.contains(add)) setLoading(add, false); });
      return;
    }

    // 3) Quick add from empty-state cards inside the drawer (core skips quick-add inside the drawer)
    var qa = closest(e.target, 'kj-cart-drawer [data-kj-quick-add]');
    if (qa) {
      e.preventDefault();
      if (qa.disabled) return;
      snapshotMeters();
      setLoading(qa, true);
      k.cart.add([{ id: qa.getAttribute('data-kj-quick-add'), quantity: 1 }], { source: 'cart-empty' })
        .catch(function () {})
        .finally(function () { if (doc.contains(qa)) setLoading(qa, false); });
      return;
    }

    // 4) Drawer qty buttons: just snapshot the meter (core performs the change)
    if (closest(e.target, 'kj-cart-drawer [data-kj-qty]')) { snapshotMeters(); return; }

    // 5) Cart page qty / remove
    var q = closest(e.target, '[data-kj-cart-section] [data-kj-qty]');
    if (q) {
      e.preventDefault();
      var line = closest(q, '[data-line]');
      if (!line) return;
      var input = line.querySelector('input[data-kj-qty-input]');
      var current = parseInt(input ? input.value : line.getAttribute('data-quantity'), 10) || 0;
      var mode = q.getAttribute('data-kj-qty');
      var next = mode === 'plus' ? current + 1 : mode === 'minus' ? current - 1 : 0;
      changePageLine(line, Math.max(0, next));
    }
  });

  function changePageLine(line, qty) {
    var k = K();
    if (!k || !line) return;
    snapshotMeters();
    line.classList.add('is-updating');
    k.cart.change(line.getAttribute('data-key') || line.getAttribute('data-line'), qty, { source: 'cart-page' })
      .catch(function (err) {
        line.classList.remove('is-updating');
        var errEl = line.querySelector('[data-kj-line-error]');
        if (errEl) { errEl.textContent = err.message; errEl.hidden = false; }
        var input = line.querySelector('input[data-kj-qty-input]');
        if (input) input.value = line.getAttribute('data-quantity');
      });
  }
  doc.addEventListener('change', function (e) {
    var input = closest(e.target, '[data-kj-cart-section] input[data-kj-qty-input]');
    if (!input) return;
    var line = closest(input, '[data-line]');
    var qty = Math.max(0, parseInt(input.value, 10) || 0);
    if (String(qty) === line.getAttribute('data-quantity')) return;
    changePageLine(line, qty);
  });
  doc.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var input = closest(e.target, '[data-kj-cart-section] input[data-kj-qty-input]');
    if (!input) return;
    e.preventDefault();
    input.blur();
  });

  /* ---------- checkout loading feedback ---------- */
  doc.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || (form.id !== 'kj-cart-form' && form.id !== 'kj-mcart-form')) return;
    var btn = e.submitter && e.submitter.hasAttribute('data-kj-checkout') ? e.submitter : null;
    if (btn) setTimeout(function () { btn.classList.add('is-loading'); }, 0);
  });
  window.addEventListener('pageshow', function () {
    doc.querySelectorAll('[data-kj-checkout].is-loading').forEach(function (b) { b.classList.remove('is-loading'); });
  });

  /* ---------- cart page: sticky checkout bar on mobile ---------- */
  var barIO = null;
  function initBar() {
    if (barIO) { barIO.disconnect(); barIO = null; }
    var root = pageRoot();
    if (!root) return;
    var bar = root.querySelector('[data-kj-mcart-bar]');
    var main = root.querySelector('.kj-mcart__aside [data-kj-checkout]');
    if (!bar || !main || !('IntersectionObserver' in window)) return;
    barIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var show = !en.isIntersecting && en.boundingClientRect.top > 0;
        bar.classList.toggle('is-visible', show);
      });
    }, { threshold: 0 });
    barIO.observe(main);
  }

  /* ---------- lifecycle ---------- */
  doc.addEventListener('kj:cart:rendered', function (e) {
    var d = (e.detail && e.detail.el) || drawerEl();
    syncSelects(d);
    animateMeters(d);
    if (d && d.classList.contains('is-open')) restoreFocus(d);
  });
  doc.addEventListener('kj:cart:updated', function (e) {
    var root = pageRoot();
    if (root) {
      var cart = e.detail && e.detail.cart;
      if (cart && root.getAttribute('data-item-count') !== String(cart.item_count)) root.setAttribute('data-item-count', cart.item_count);
      syncSelects(root);
      animateMeters(root);
      initBar();
      restoreFocus(root);
      if (window.KJ && KJ.init) KJ.init(root);
    }
    var d = drawerEl();
    if (d && d.classList.contains('is-open')) announce(e.detail && e.detail.cart);
  });

  // Theme editor: open the drawer when its section is selected
  doc.addEventListener('shopify:section:select', function (e) {
    var d = e.target && e.target.querySelector && e.target.querySelector('kj-cart-drawer');
    if (d && d.open) d.open();
  });
  doc.addEventListener('shopify:section:deselect', function (e) {
    var d = e.target && e.target.querySelector && e.target.querySelector('kj-cart-drawer');
    if (d && d.close) d.close();
  });

  function boot() {
    snapshotMeters();
    syncSelects(doc);
    initBar();
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', boot); else boot();
})();
